// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-box {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center; /* Vertically center */
  /* border: 1px solid rgb(0, 81, 255); */
  /* margin-top: 40px; */
  width: 50%;
  /* border: 1px solid red; */
  height: 100vh;
  padding: 25px;
}

.login-box .logo-box {
  color: white;
  max-width: 100%;
  width: 400px;
  /* margin-bottom: 70px; */
  text-align: "center";
}

.logo-box img {
  max-width: 100%;
  height: auto;
  width: 400px;
  /* border: 1px solid pink; */
}

.logo-box svg {
  max-width: 100%;
  height: auto;
  width: 400px;
  /* border: 1px solid pink; */
}

.login-box .login-form {
  color: white;
  max-width: 100%;
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  width: 400px;
  margin-top: 12rem;
  /* border: 1px solid pink; */
}

.custom-width {
  width: 100%;
  /* border: 1px solid red; */
  /* height: inherit; */
}

/* Forgot Password */
.custom-forgot-password {
  color: #ffffff !important;
  text-decoration: none !important;
  font-family: "Karla" !important;
  font-weight: 400 !important;
  font-size: 18px !important;
  line-height: 21.5px !important;
  background-color: transparent !important;
  padding: 0 !important;
  /* margin: 0 !important; */
  border: none !important;
  cursor: pointer;
}

.forgot-password-error {
  /* border: 1px solid red; */
  color: #e77b7b !important;
  text-align: justify !important;
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 18px !important;
  line-height: 27px !important;
}
`, "",{"version":3,"sources":["webpack://./src/features/auth/styles/loginForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB,EAAE,sBAAsB;EAC3C,uCAAuC;EACvC,sBAAsB;EACtB,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;EAC9B,wCAAwC;EACxC,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B","sourcesContent":[".login-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center; /* Vertically center */\n  /* border: 1px solid rgb(0, 81, 255); */\n  /* margin-top: 40px; */\n  width: 50%;\n  /* border: 1px solid red; */\n  height: 100vh;\n  padding: 25px;\n}\n\n.login-box .logo-box {\n  color: white;\n  max-width: 100%;\n  width: 400px;\n  /* margin-bottom: 70px; */\n  text-align: \"center\";\n}\n\n.logo-box img {\n  max-width: 100%;\n  height: auto;\n  width: 400px;\n  /* border: 1px solid pink; */\n}\n\n.logo-box svg {\n  max-width: 100%;\n  height: auto;\n  width: 400px;\n  /* border: 1px solid pink; */\n}\n\n.login-box .login-form {\n  color: white;\n  max-width: 100%;\n  width: 400px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  max-width: 100%;\n  width: 400px;\n  margin-top: 12rem;\n  /* border: 1px solid pink; */\n}\n\n.custom-width {\n  width: 100%;\n  /* border: 1px solid red; */\n  /* height: inherit; */\n}\n\n/* Forgot Password */\n.custom-forgot-password {\n  color: #ffffff !important;\n  text-decoration: none !important;\n  font-family: \"Karla\" !important;\n  font-weight: 400 !important;\n  font-size: 18px !important;\n  line-height: 21.5px !important;\n  background-color: transparent !important;\n  padding: 0 !important;\n  /* margin: 0 !important; */\n  border: none !important;\n  cursor: pointer;\n}\n\n.forgot-password-error {\n  /* border: 1px solid red; */\n  color: #e77b7b !important;\n  text-align: justify !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 400 !important;\n  font-size: 18px !important;\n  line-height: 27px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
